import React from 'react';
import FeatureModels from '../../../../models/Feature';
import { CheckboxContained, CheckboxContainedGroup } from '@homeexchange/design';
import i18n from '../../../../i18n';
export var SurroundingTags = function (_a) {
    var onUpdate = _a.onUpdate, _b = _a.surrounding, surrounding = _b === void 0 ? [] : _b;
    var getLabel = function (feature) {
        var labels = FeatureModels.AMENITIES_LABEL;
        return i18n.t("home:feature-surrounding-".concat(feature.icon));
    };
    return (React.createElement("div", null,
        React.createElement(CheckboxContainedGroup, { collapsible: true, collapsed: true, showLines: 2, showMore: i18n.t('home:show-more'), showLess: i18n.t('home:show-less') }, FeatureModels.FEATURES.filter(function (feature) { return feature.category === FeatureModels.SURROUNDING_TAGS; }).map(function (feature) { return (React.createElement(CheckboxContained, { name: 'surrounding', type: "checkbox", key: "surrounding-".concat(feature.icon), label: getLabel(feature), onChange: onUpdate, value: feature.icon, icon: feature.icon, checked: surrounding.includes(feature.icon), id: "gtm-track-".concat(feature.icon) })); }))));
};
export default SurroundingTags;
